import supportArticle from "@faire/web-api--source/routes/www/support/articles/articleId";

const EXCLUSIVITY_ARTICLE_ID = "19903209185947";

export const EXCLUSIVITY_ARTICLE = supportArticle(EXCLUSIVITY_ARTICLE_ID);

export const ENDING_SOON_DAYS = 90;
export const SIX_MONTHS_DAYS = 180;

export type DetailModalOriginType =
  | "brand"
  | "product"
  | "post-checkout"
  | "my-brands"
  | "my-orders";

export enum PROMO_BANNER_ORIGIN {
  MY_BRANDS_CARD = "MY_BRANDS_CARD",
  MY_BRANDS_HEADER = "MY_BRANDS_HEADER",
  POST_ORDER = "POST_ORDER",
  BRAND_PAGE = "BRAND_PAGE",
}

export const EXCLUSIVITY_ACTIVATION_EXISTING_AGREEMENT_ERROR =
  "Exclusivity agreement with brand already exists in retailer's area";
